// extracted by mini-css-extract-plugin
module.exports = {"Popover":"Popover--3Cegg","Close":"Close--2_umt"};